<template>
  <v-dialog v-model="modal" width="600">
    <v-card dark color="#1e1e2e">
      <v-card-title class="headline">
        {{ ageRating && ageRating.id ? 'Editar Faixa Etária' : 'Nova Faixa Etária' }}
      </v-card-title>

      <v-card-text>
        <!-- Preview do rótulo gerado automaticamente -->
        <div v-if="ageRating && ageRating.age" class="mb-4 d-flex align-center">
          <span class="grey--text text--lighten-1 mr-2">Rótulo gerado:</span>
          <v-chip :color="ratingColor(ageRating.age)" :dark="ageRating.age !== 12" :light="ageRating.age === 12" small>
            A{{ ageRating.age }}
          </v-chip>
          <span class="caption grey--text text--lighten-2 ml-2">
            (gerado automaticamente pelo sistema)
          </span>
        </div>

        <v-text-field
          label="Idade mínima (ex: 12)"
          v-model.number="ageRating.age"
          type="number"
          min="0"
          max="99"
          outlined
          dense
          class="custom-input"
          hint="Valores comuns: 10, 12, 14, 16"
          persistent-hint
        ></v-text-field>

        <v-text-field
          label="Descrição do conteúdo"
          v-model="ageRating.description"
          outlined
          dense
          class="custom-input mt-3"
          placeholder="Ex: Violência extrema"
          counter="100"
          maxlength="100"
        ></v-text-field>
      </v-card-text>

      <v-card-actions>
        <v-btn color="error" @click="fecharModal">Cancelar</v-btn>
        <v-spacer></v-spacer>
        <v-btn class="zinnes-primary-btn" dark @click="salvar" :loading="loading">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import AgeRatingService from '@/server/AgeRatingService';

export default {
  name: 'ModalAgeRating',
  props: {
    list: {
      type: Function,
    },
  },
  data: () => ({
    modal:   false,
    service: new AgeRatingService(),
    loading: false,
  }),
  computed: {
    ageRating: {
      get()     { return this.$store.getters['getAgeRating']; },
      set(dado) { this.$store.dispatch('setAgeRating', dado); },
    },
  },
  methods: {
    abrirModal() {
      this.modal = true;
    },
    fecharModal() {
      this.modal     = false;
      this.ageRating = null;
    },
    ratingColor(age) {
      if (age <= 10) return '#0095DA';
      if (age <= 12) return '#FBC115';
      if (age <= 14) return '#F58220';
      return '#EC1D25';
    },
    salvar() {
      if (!this.ageRating.age || !this.ageRating.description) {
        return;
      }
      this.loading = true;

      const payload = {
        id:          this.ageRating.id,
        age:         this.ageRating.age,
        description: this.ageRating.description,
        // "rating" NUNCA é enviado — é gerado no backend como "A" + age
      };

      if (this.ageRating.id) {
        this.service.edit(payload)
          .then(() => {
            this.list();
            this.fecharModal();
            this.loading = false;
          })
          .catch(() => { this.loading = false; });
      } else {
        this.service.create(payload)
          .then(() => {
            this.list();
            this.fecharModal();
            this.loading = false;
          })
          .catch(() => { this.loading = false; });
      }
    },
  },
};
</script>
